import { isFormValid, setError, syncProfileMarker } from '../../../../library/Core/SmartFunctions';
import { DispatchEvent, State } from '../../../../library/Core/SmartTypes';
import logger from '../../../../library/Core/logger';
import StudentService from '../../../../services/student.service';
import { navigateToNextStep } from '../../services/profile-next-step-navigator';

export const handleNext = (
    event: React.SyntheticEvent<HTMLButtonElement>,
    state: State,
    dispatch: (dispatchEvent: DispatchEvent) => void,
    globalState: any,
    globalDispatch: (dispatchEvent: DispatchEvent) => void,
    sessionState: any,
    sessionDispatch: (dispatchEvent: DispatchEvent) => void
) => {
    event.preventDefault();

    if (!checkAnyOneSelect(state, dispatch)) {
        alert('Please Select Atleast One option!');
        return;
    }
    
    const recruiterInfo = state?.data?.recruiterInfo || {};

    const recruiterIntentInfo = {
    ...recruiterInfo,
    recruiterProfile:
        recruiterInfo.email && recruiterInfo.mobileNumber
        ? 'MARKED_AS_RECRUITER'
        : 'POTENTIAL_RECRUITER',
    };

    StudentService.pageSave(
        state.routeInfo.id,
        state.routeInfo.pageName,
       recruiterIntentInfo,
    ).then(() => {
        return state.actions['REDIRECT'](`/alumni/${state.routeInfo.id}/recruiter-basic-info`);
    });
};


const checkAnyOneSelect = (state: State, dispatch: (dispatchEvent: DispatchEvent) => void) => {
    const recruiterInfoData = state?.data['recruiterInfo'];
    let isFormValid = true;
    const normalizeBool = (val: any) => val === true || val === 1 || val === '1';

    const anySelected =
        normalizeBool(recruiterInfoData.hasExpressedInterestInRecruitment) ||
        normalizeBool(recruiterInfoData?.hasRelevantSkills) ||
        normalizeBool(recruiterInfoData?.hasTrackRecord) ||
        normalizeBool(recruiterInfoData?.hasSomeoneReferred) ||
        normalizeBool(recruiterInfoData?.hasBeenRecruiterBefore);
    if(!anySelected){
        setError(`recruiterInfo.hasExpressedInterestInRecruitment`, [`Please Select Atleast One `], dispatch);
       isFormValid = false;
    }
    return isFormValid;
};